import { BRAND_NAME, language } from "@chef/constants";

export const intl = (
  {
    no: {
      RECEIPT: "Oversikt",
      FORMAT_PORTIONS_MEALS: ({
        portions,
        meals,
      }: {
        portions: number;
        meals: number;
      }) => `${portions} pers, ${meals} retter`,
      FORMAT_ADDONS: (addonCount: number) =>
        addonCount === 1 ? "dagligvare" : "dagligvarer",
      FREIGHT_FEE: "Levering",
      TOTAL: "Totalt",
    },

    dk: {
      RECEIPT: "Oversigt",
      FORMAT_PORTIONS_MEALS: ({
        portions,
        meals,
      }: {
        portions: number;
        meals: number;
      }) => `${portions} pers, ${meals} retter`,
      FORMAT_ADDONS: (addonCount: number) =>
        addonCount === 1 ? "specialvare" : "specialvarer",
      FREIGHT_FEE: "Levering",
      TOTAL: "I alt",
    },

    se: {
      RECEIPT: "Översikt",
      FORMAT_PORTIONS_MEALS: ({
        portions,
        meals,
      }: {
        portions: number;
        meals: number;
      }) => `${portions} pers, ${meals} middagar`,
      FORMAT_ADDONS: () => "livsmedel",
      FREIGHT_FEE: "Leverans",
      TOTAL: "Totalt",
    },
  } as const
)[language];

export const brand = (
  {
    AMK: {
      IMAGE_URL:
        "https://ggfrontendassets.azureedge.net/publicassets/adams_mealbox.png",
    },
    GL: {
      IMAGE_URL:
        "https://ggfrontendassets.azureedge.net/publicassets/vegetables_2.png",
    },
    RN: {
      IMAGE_URL:
        "https://ggfrontendassets.azureedge.net/publicassets/retnemt_mealbox.png",
    },
    LMK: {
      IMAGE_URL:
        "https://ggfrontendassets.azureedge.net/publicassets/linas_mealbox.png",
    },
  } as const
)[BRAND_NAME];
